import {debounce} from '../_functions'
import $ from 'jquery'
import {lockBody, unlockBody} from "../_utils";

document.addEventListener("DOMContentLoaded", function (dom) {
    const trainingList = dom.target.querySelectorAll('.feed-training');
    const searchInput = dom.target.querySelector('.js-training-search-input');
    const categorySelect = dom.target.querySelector('.js-training-category');

    if (trainingList.length && searchInput) {
        const filterTrainings = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            trainingList.forEach(post => {
                const title = post.querySelector('.js-title');
                const titleText = title ? title.innerText.toLowerCase() : '';
                const titleData = post.dataset.title;
                const postTerms = JSON.parse(post.dataset.terms || '[]');

                var matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                if ( ! matchSearch ) {
                    matchSearch = searchTerm === '' || titleData.includes(searchTerm);
                }
                const matchCategory = categorySelect.value === '' || postTerms.includes(categorySelect.value);

                if (matchSearch && matchCategory) {
                    post.classList.remove('hidden');
                } else {
                    post.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterTrainings, 300);
        searchInput.addEventListener('input', handleInput);

        categorySelect.addEventListener('change', filterTrainings);

        filterTrainings();
    }
});

let trainingFiltersOpen = false;

$(document).on('click', '.js-open-training-filters', function (e) {
    e.preventDefault();

    $('.js-training-filters').slideDown(500);
    $('.js-training-overlay').fadeIn(500);

    trainingFiltersOpen = true;
    lockBody();
});

$(document).on('click', '.js-close-training-filters, .js-training-overlay', function (e) {
    e.preventDefault();

    $('.js-training-filters').slideUp(500);
    $('.js-training-overlay').fadeOut(500);

    trainingFiltersOpen = false;
    unlockBody();
});

const media = window.matchMedia('(min-width: 992px)');

media.addEventListener('change', function (e) {
    if (e.matches && trainingFiltersOpen) {
        trainingFiltersOpen = false;

        unlockBody();

        $('.js-training-overlay').hide();
        $('.js-training-filters').removeAttr('style');
    }
});